import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { selectSelectedSchool } from "app/modules/schools/selectors";

export default function useHideExportButton() {
  const selectedSchool = useSelector(selectSelectedSchool);
  const upcomingDueDate = selectedSchool?.upcomingDueDate;
  const daysRemaining = upcomingDueDate
    ? dayjs(upcomingDueDate).diff(dayjs(), "day")
    : 0;
  return daysRemaining <= 0;
}
